import { Component, Inject, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import * as firebase from 'firebase';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.css']
})
export class AccountSettingsComponent implements OnInit {

  message: any;
  hidePassword = true;
  hidePassword2 = true;
  hidePassword3 = true;

  loginModel: any = {
    oldpassword:'',
    newpassword:'',
    confirmpassword:'',

  };
  role:string;
  passcodes = ["","","",""];

  hidePasscode = true;
  hidePasscode2 = true;
  hidePasscode3 = true;
  hidePasscode4 = true;
  email:any;

  constructor(
    private dialogRef: MatDialogRef<AccountSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private toast: ToastrService,
    private angularFireAuth: AngularFireAuth,
  ) {
    this.angularFireAuth.authState.subscribe(auth => {
      this.email = auth.email;
    });
    this.message = data;
  }

  async ngOnInit(){ }
  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }

  change(){
    if(this.loginModel.newpassword !== this.loginModel.confirmpassword){
      this.toast.error('New Password not same',"Warning")
      return;
    }

    this.angularFireAuth.authState.subscribe(async authState =>{
      if(authState === null){
      } else{
        const cre = firebase.auth.EmailAuthProvider.credential(authState.email, this.loginModel.oldpassword);
        authState.reauthenticateWithCredential(cre).then(r=>{
          authState.updatePassword(this.loginModel.newpassword).then(update=>{
            this.toast.success('Change password successful',"Success")
            this.dialogRef.close(true);
          })
        }).catch(error=>{
          this.toast.error('Wrong old password',"Failed to change")

        })

      }

    })
  }

 
}
